const PATH_PREFIX = '/log';

export default [
  {
    name: 'log.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'log.sms',
    path: `${PATH_PREFIX}/sms`,
  },
  {
    name: 'log.email',
    path: `${PATH_PREFIX}/email`,
  },
  {
    name: 'log.minisite/ssl',
    path: `${PATH_PREFIX}/minisite/ssl`,
  },
  {
    name: 'log.cron',
    path: `${PATH_PREFIX}/cron`,
  },
];
